import {
    Boot
} from '@wangeditor/editor'
//import format from 'xml-formatter'
// 定义菜单 class
class MyButtonMenu {
    title = '源码'
    tag = 'button'
    alwaysEnable = true
    isActive() {
        return this.isactive
    }
    getValue() {
        return ''
    }
    isDisabled() {
        return false
    }
    exec() {
        const div = document.querySelectorAll('.hideSource')[0]
        const editor = document.querySelectorAll('.editor')[0]
        if (div.style.display === 'block') {
            div.style.display = 'none'
            editor.style.display = 'block'
            this.isactive = false;
        } else {
            div.style.display = 'block'
            editor.style.display = 'none'
            this.isactive = true;
        }
    }
}


// 定义菜单配置
export const menuSource = {
    key: 'menusource', // menu key ，唯一。注册之后，可配置到工具栏
    factory() {
        return new MyButtonMenu()
    },
}
Boot.registerMenu(menuSource)